<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'icon'].includes(value),
  },
});

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { accountScopedRoute } = useAccount();
const notificationMetadata = useMapGetter('notifications/getMeta');

const unreadCount = computed(() => {
  const count = notificationMetadata.value?.unreadCount;
  if (!count) return '';

  return count < 100 ? `${count}` : '99+';
});

const isHubRoute = computed(() =>
  ['inbox_view', 'inbox_view_conversation'].includes(route.name)
);

function openNotificationHub() {
  if (isHubRoute.value) return;
  router.push(accountScopedRoute('inbox_view'));
}
</script>

<template>
  <button
    v-tooltip="t('SIDEBAR.NOTIFICATIONS')"
    class="relative grid flex-shrink-0 hover:bg-n-alpha-2 place-content-center text-n-slate-11 hover:text-n-slate-12"
    :class="variant === 'icon' ? 'size-11 rounded-xl' : 'size-8 rounded-xl'"
    :aria-label="t('SIDEBAR.NOTIFICATIONS')"
    data-testid="sidebar-notification-bell"
    @click="openNotificationHub"
  >
    <span class="i-ph-bell size-5" />
    <span
      v-if="unreadCount"
      class="absolute grid px-1 leading-none rounded-full min-h-4 min-w-4 -top-1 -right-1 bg-n-ruby-9 place-items-center text-[9px] font-semibold text-white"
    >
      {{ unreadCount }}
    </span>
  </button>
</template>
